var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("img", {
        staticClass: "logo",
        staticStyle: { width: "120px", height: "auto" },
        attrs: { src: _vm.logo }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav-items-container" },
        [
          _c(
            "flexbox",
            { staticStyle: { width: "auto" } },
            _vm._l(_vm.navList, function(item, index) {
              return _c(
                "router-link",
                {
                  key: index,
                  staticClass: "nav-item",
                  style: {
                    color:
                      item.type == _vm.navIndexChild ? "#3E84E9" : "#333333"
                  },
                  attrs: { to: item.path },
                  nativeOn: {
                    click: function($event) {
                      _vm.navItemsClick(item.type)
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "wukong",
                    class: item.icon,
                    staticStyle: { "margin-right": "10px" },
                    style: {
                      color:
                        item.type == _vm.navIndexChild ? "#3E84E9" : "#333333"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "nav-item-title" }, [
                    _vm._v(_vm._s(item.title))
                  ])
                ]
              )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom",
            "visible-arrow": false,
            "popper-class": "no-padding-popover",
            width: "200",
            trigger: "click"
          }
        },
        [
          _c("div", { staticClass: "handel-items" }, [
            _c(
              "div",
              {
                staticClass: "handel-item",
                on: {
                  click: function($event) {
                    _vm.handleClick("CTJR")
                  }
                }
              },
              [
                _c("i", { staticClass: "wukong wukong-goout" }),
                _vm._v("长涛金融")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "handel-item",
                on: {
                  click: function($event) {
                    _vm.handleClick("CTXD")
                  }
                }
              },
              [
                _c("i", { staticClass: "wukong wukong-goout" }),
                _vm._v("长涛网络小贷")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "handel-item",
                on: {
                  click: function($event) {
                    _vm.handleClick("CTFD")
                  }
                }
              },
              [
                _c("i", { staticClass: "wukong wukong-goout" }),
                _vm._v("长涛房抵")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "handel-item",
                on: {
                  click: function($event) {
                    _vm.handleClick("person")
                  }
                }
              },
              [
                _c("i", { staticClass: "wukong wukong-personcenter" }),
                _vm._v("个人中心")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "handel-item",
                on: {
                  click: function($event) {
                    _vm.handleClick("goout")
                  }
                }
              },
              [
                _c("i", { staticClass: "wukong wukong-goout" }),
                _vm._v("退出登录")
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "user-container",
              attrs: { slot: "reference" },
              slot: "reference"
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "photo",
                    rawName: "v-photo",
                    value: _vm.userInfo,
                    expression: "userInfo"
                  },
                  {
                    name: "lazy",
                    rawName: "v-lazy:background-image",
                    value: _vm.$options.filters.filterUserLazyImg(
                      _vm.userInfo.img
                    ),
                    expression:
                      "$options.filters.filterUserLazyImg(userInfo.img)",
                    arg: "background-image"
                  }
                ],
                key: _vm.userInfo.img,
                staticClass: "user-img div-photo"
              }),
              _vm._v(" "),
              _c("i", { staticClass: "el-icon-caret-bottom mark" })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }